export default {
  // Tab 标签
  评估: "评估",

  // 搜索字段标签
  供应商编号: "供应商编号",
  供应商名称: "供应商名称",
  物料编号: "物料编号",
  物料名称: "物料名称",
  评估状态: "评估状态",
  申请人: "申请人",
  请输入供应商编号: "请输入供应商编号",
  请输入供应商名称: "请输入供应商名称",
  请输入物料编号: "请输入物料编号",
  请输入物料名称: "请输入物料名称",
  请选评估状态: "请选评估状态",
  请输入申请人名字: "请输入申请人名字",

  // 表格列标题
  评估发起人: "评估发起人",
  发起时间: "发起时间",
  操作: "操作",

  // 表格标题
  评估列表: "评估列表",

  // 按钮文本
  申请评估: "申请评估",
  编辑: "编辑",
  删除: "删除",
  查看: "查看",
  发起VSMC会议: "发起VSMC会议",
  重新评估: "重新评估",
  暂存: "暂存",
  提交: "提交",

  // 评估状态值
  草稿: "草稿",
  部门评估中: "部门评估中",
  部门评估完成: "部门评估完成",
  审批中: "审批中",
  已驳回: "已驳回",
  已通过: "已通过",

  // 消息提示
  获取用户列表失败: "获取用户列表失败",
  获取评估数据失败: "获取评估数据失败",
  "获取评估数据失败，请重试": "获取评估数据失败，请重试",
  评估申请已成功提交: "评估申请已成功提交",
  "提交失败，请重试": "提交失败，请重试",
  提交评估申请失败: "提交评估申请失败",
  "提交评估申请失败，请重试": "提交评估申请失败，请重试",
  删除功能开发中: "删除功能开发中",
  搜索参数: "搜索参数",
  重置搜索: "重置搜索",
  查看评估记录: "查看评估记录",
  删除评估记录: "删除评估记录",

  // 评估表单 - 申请人信息
  申请人信息: "申请人信息",
  员工姓名: "员工姓名",
  员工编号: "员工编号",
  创建日期: "创建日期",
  部门: "部门",
  岗位: "岗位",
  邮箱: "邮箱",
  邮箱格式不正确: "邮箱格式不正确",

  // 评估表单 - 供应商基本信息
  供应商基本信息: "供应商基本信息",
  "供应商名称（中文）": "供应商名称（中文）",
  "供应商名称（英文）": "供应商名称（英文）",
  供应商状态: "供应商状态",
  新供应商: "新供应商",
  现有供应商: "现有供应商",
  物料状态: "物料状态",
  物料用途类别: "物料用途类别",
  原料: "原料",
  辅料: "辅料",
  包装材料: "包装材料",
  物料编号如有: "物料编号(如有)",
  注册市场: "注册市场",
  中国内地: "中国内地",
  中国香港: "中国香港",
  美国: "美国",
  其他: "其他",
  产地区域: "产地区域",
  中国: "中国",
  欧美: "欧美",
  亚太: "亚太",

  // 通用提示
  请输入: "请输入",
  请选择: "请选择",

  // 编辑表单 - VSMC会议评审
  VSMC会议评审: "VSMC会议评审",
  发起二维码审批: "发起二维码审批",
  审核意见: "审核意见",
  同意: "同意",
  驳回: "驳回",
  需呈GM决策: "需呈GM决策",
  意见说明: "意见说明",
  请输入意见说明: "请输入意见说明",

  // 编辑表单 - 评审人签批
  评审人签批意见: "评审人签批意见",
  刷新: "刷新",
  未签批: "未签批",
  评审意见: "评审意见",
  暂无意见: "暂无意见",
  暂无备注: "暂无备注",

  // 编辑表单 - 评估详情
  暂无数据: "暂无数据",
  暂无该阶段的评估数据: "暂无该阶段的评估数据",
  暂无评估数据: "暂无评估数据",
  发送邀请: "发送邀请",
  获取评估数据成功: "获取评估数据成功",
  获取的评估数据中不包含该阶段的信息请重试:
    "获取的评估数据中不包含该阶段的信息，请重试",
  总体评估结果: "总体评估结果",
  评估详情: "评估详情",
  上一个阶段: "上一个阶段",
  下一个阶段: "下一个阶段",
  优评: "优评",
  中评: "中评",
  差评: "差评",
  差: "差",
  中: "中",
  优: "优",
  没有可用的form实例: "没有可用的 form 实例！",
  加载中: "加载中...",

  // 模态框标题
  供应商准入评估表: "供应商准入评估表",
  单号: "单号",

  // 编辑模式按钮
  发起会议审批: "发起会议审批",
  流程动态: "流程动态",

  // Tab 标签
  供应商准入评估: "供应商准入评估",
  我的评估: "我的评估",
  评估邀请: "评估邀请",

  // 评估状态
  评估中: "评估中",
  已评估: "已评估",
  未评估: "未评估",

  // 表单标签和提示
  评估阶段: "评估阶段",
  评估人: "评估人",
  请选择评估阶段: "请选择评估阶段",
  请选择评估人: "请选择评估人",

  // 按钮和操作
  删除邀请: "删除邀请",
  确认要删除这条邀请吗: "确认要删除这条邀请吗？",
  确认: "确认",
  取消: "取消",
  删除成功: "删除成功",
  删除失败: "删除失败",
};
